












import { defineComponent } from '@vue/composition-api';

import FreshDialog from '@/components/FreshDialog.vue';
import InitiateAnalysisMenu from './InitiateAnalysisMenu.vue';
import CompletedAnalysesMenu from './CompletedAnalysesMenu.vue';
import { initiateAnalysisOpen } from '../state';

export default defineComponent({
  name: 'Analysis',
  components: { FreshDialog, InitiateAnalysisMenu, CompletedAnalysesMenu },
  setup() {
    return { initiateAnalysisOpen };
  },
});
